import React, { useEffect } from 'react'
import {
  loadPayPalAnalytics,
  recordFptiImpression,
  recordGaImpression,
  recordFptiAndGaEvent,
} from './utils'

const getLinkTrackingData = (ev) => {
  const href =
    (ev.target && ev.target.href) || (ev.currentTarget && ev.currentTarget.href)
  const hostname = window?.location?.hostname

  if (href) {
    let hrefHostDetermine = href.split('.com')
    hrefHostDetermine =
      hrefHostDetermine.length > 0
        ? hrefHostDetermine[0] + '.com'
        : hrefHostDetermine
    const isDeveloperLink =
      hrefHostDetermine && hrefHostDetermine.includes(hostname)
    const isDocsLink = isDeveloperLink && href.includes('/docs/')

    if (!isDeveloperLink || isDocsLink) {
      const linkCategory = isDocsLink ? 'docsLink' : 'externalLink'

      return `${linkCategory},click,${href},${linkCategory}-${href}`
    }
  }

  return null
}

export default function Analytics({ pathname, context }) {
  const handleClick = (ev) => {
    let el = ev.target

    // Traverse up the DOM tree to find the nearest <a> element
  if (el.nodeName !== 'A') {
    let candidate = el;
    while (candidate && candidate.nodeName !== 'A') {
      candidate = candidate.parentElement;
    }

    // Only update el if we successfully found an <a>
    if (candidate && candidate.nodeName === 'A') {
      el = candidate;
    }
    // Else keep the original el (e.g. button/input/span)
  }

    if (
      el &&
      el.getAttribute &&
      el.getAttribute('data-dxa') &&
      el.getAttribute('data-dxa') !== 'dynamic'
    ) {
      recordFptiAndGaEvent(el, context.fptiData, el.getAttribute('data-dxa'), {
        env_name: context.enviroment,
        secondaryUser: context.secondaryUser,
      })
    } else if (
      el &&
      el.nodeName === 'A' &&
      el.getAttribute('href') &&
      !el.getAttribute('data-dxa')
    ) {
      const trackingData = getLinkTrackingData(ev)
      if (trackingData) {
        recordFptiAndGaEvent(el, context.fptiData, trackingData, {
          env_name: context.enviroment,
          secondaryUser: context.secondaryUser,
        })
      }
    }
  }

  const handleDynamicEvent = (ev) => {
    recordFptiAndGaEvent(null, context.fptiData, ev.detail.dataDxaString, {
      env_name: context.enviroment,
      secondaryUser: context.secondaryUser,
    })
  }

  const handleHashChange = (ev) => {
    const el = ev.target
    const newHash = el.location && el.location.hash
    recordFptiAndGaEvent(
      el,
      context.fptiData,
      `inPageAnchor, click, ${newHash}`,
      { env_name: context.enviroment, secondaryUser: context.secondaryUser },
    )
  }

  // record event on specific events
  useEffect(() => {
    loadPayPalAnalytics(context.fptiData)
    document.addEventListener('click', handleClick)
    document.addEventListener('data-dxa-dynamic-event', handleDynamicEvent)
    document.addEventListener('hashchange', handleHashChange)
    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('data-dxa-dynamic-event', handleDynamicEvent)
      document.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  // record impression whenever a page loads
  useEffect(() => {
    // record impression
    recordFptiImpression(context.fptiData)
    recordGaImpression(pathname)
  }, [pathname])

  return <div />
}
